module.exports = __webpack_public_path__ + "img/icon_xiazai_yonghu@3x.8a067e57.png";